var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
        },
        [
          _c("div", { staticClass: "dialog__body" }, [
            _c("p", { staticClass: "dialog__lead" }, [
              _vm._v(" " + _vm._s(_vm.$t(_vm.leadKey)) + " "),
            ]),
          ]),
          _c("footer", { staticClass: "dialog__footer" }, [
            _c(
              "button",
              {
                staticClass: "dialog__ok-button",
                attrs: { type: "button", disabled: _vm.isSubmitting },
                on: { click: _vm.onClickConfirm },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isSubmitting
                        ? _vm.$t("proofreadingAiConfirmDialog.submitting")
                        : _vm.$t("proofreadingAiConfirmDialog.confirm", {
                            fish: _vm.formattedFish,
                          })
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__cancel-button",
                attrs: { type: "button", disabled: _vm.isSubmitting },
                on: { click: _vm.onClickCancel },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingAiConfirmDialog.cancel")) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }